module.exports = __webpack_public_path__ + "static/media/notes.2b0dfd9a.svg";